module.exports = __webpack_public_path__ + "img/background-login.6fdfe939.gif";